/**
 * Returns true when the app is running inside an Electron shell.
 *
 * Both preload scripts (riveros and selfhosted) expose window.riverOS via
 * contextBridge. This is the canonical, synchronous signal — no userAgent
 * sniffing, no process.env, no undefined window.electronAPI.
 */
export function isElectron(): boolean {
  return typeof window !== 'undefined' && !!(window as any).riverOS;
}

/**
 * True when local file system access is available via the River desktop preload.
 * Checks for the canonical riverOS.fileSystem API first (readFile + runShell),
 * then falls back to the electron.ipcRenderer.invoke wrapper.
 */
export function hasLocalFileSystemIPC(): boolean {
  if (typeof window === 'undefined') return false;
  // Prefer the proper riverOS API (exposed via contextBridge, no whitelist issues)
  if (typeof (window as any).riverOS?.fileSystem?.readFile === 'function') return true;
  return typeof (window as any).electron?.ipcRenderer?.invoke === 'function';
}
